import styled from "styled-components"
import {colors} from 'styles/template/variables'

interface GridProps {
  numberOfColumns?: number;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
` 

export const Content = styled.div`
  flex: 1;

  &+div{
    margin-left: 2rem;
  }
`

export const Grid = styled.div<GridProps>`
  grid-template-columns: ${props => "auto ".repeat(props.numberOfColumns ?? 1)};
  display: grid;
  gap: 32px;
`

export const Row = styled.div`
  display: flex;

  .remove-contact {
    width: 53px;
    height: 53px;
  }
`
export const Col = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  padding-right: 32px;

  &.d-flex {
    display: flex;
  }
`

export const IconContainer = styled.img`
  background-color: ${colors.gray100};
  padding: 16px;
  width: 48px;
  height: 48px;
  border-radius: 8px;
`